import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private userFoundSubject = new BehaviorSubject<boolean>(true);
    userFound$ = this.userFoundSubject.asObservable();

    setUserFound(value: boolean) {
        this.userFoundSubject.next(value);
        localStorage.setItem('userFound', JSON.stringify(value));
    }
}